import axios from "axios";
import _ from "lodash";
import {
  CreateDashboardRequest,
  CreateSlideTemplateRequest,
  Dashboard,
  DashboardParams,
  DashboardUserResponse,
  MessageResponse,
  SlideTemplate,
  SlideTemplateParams,
  User,
} from "../types/api";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/api/mydashboards`,
});

export const getDashboards = (params?: DashboardParams) =>
  api.get<Dashboard[]>("/dashboards", { params }).then((res) => res.data);

export const getDashboardUsers = () =>
  api.get<DashboardUserResponse>(`/dashboards/users`).then((res) => res.data);

export const getDashboard = (id: string) =>
  api.get<Dashboard>(`/dashboards/${id}`).then((res) => res.data);

export const getSlideTemplates = (params?: SlideTemplateParams) =>
  api
    .get<SlideTemplate[]>("/slidetemplates", { params })
    .then((res) => res.data);

export const getSlideTemplate = (id: string) =>
  api.get<SlideTemplate>(`/slidetemplates/${id}`).then((res) => res.data);

export const updateDashboard = ({
  _id,
  ...updatedDashboard
}: Partial<Dashboard>) =>
  api
    .put<MessageResponse>(`/dashboards/${_id}`, updatedDashboard)
    .then((res) => res.data);

export const deleteDashboard = (id: string) =>
  api.delete<MessageResponse>(`/dashboards/${id}`).then((res) => res.data);

export const createDashboard = (dashboard: Partial<CreateDashboardRequest>) =>
  api.post<Dashboard>(`/dashboards`, dashboard).then((res) => res.data);

export const createSlideTemplate = (
  slideTemplate: Partial<CreateSlideTemplateRequest>
) =>
  api
    .post<SlideTemplate>(`/slidetemplates`, slideTemplate)
    .then((res) => res.data);

export const updateSlideTemplate = ({
  _id,
  ...updatedSlideTemplate
}: Partial<SlideTemplate>) =>
  api
    .put<MessageResponse>(`/slidetemplates/${_id}`, updatedSlideTemplate)
    .then((res) => res.data);

export const deleteSlideTemplate = (id: string) =>
  api.delete<MessageResponse>(`/slidetemplates/${id}`).then((res) => res.data);

export const shareDashboard = async ({
  id,
  usersSharedWith,
  existingUsers,
}: {
  id: string;
  usersSharedWith: User[];
  existingUsers: string[];
}) => {
  const data = await api
    .put<MessageResponse>(`/dashboards/share/${id}`, { usersSharedWith })
    .then((res) => res.data);
  await axios.post<MessageResponse>(
    `${process.env.REACT_APP_SERVER_URL}/workflow/dashboardnotification`,
    {
      userIds: _.differenceBy(
        usersSharedWith.map((user) => user.id),
        existingUsers
      ),
      dashboardId: id,
    }
  );
  return data;
};
